import { CreateAffiliateFirmProps } from '@commenda/types';
import { fetcher } from '@commenda/utils';

export async function createAffiliateFirm(body: CreateAffiliateFirmProps) {
  const response = await fetcher('affiliate-firms', {
    method: 'POST',
    body,
  });

  return response;
}
